const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全网监测，热点事件第一时间推送，吃瓜永远快人一步。',
  },
  {
    icon: 'ri-stack-line',
    title: '全面归档',
    desc: '完整时间线与事件脉络，每一个瓜都从头到尾帮你梳理清楚。',
  },
  {
    icon: 'ri-team-line',
    title: '万人围观',
    desc: '8.6万吃瓜群众实时讨论，热门话题日均讨论量突破100万条。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '理性吃瓜',
    desc: '标注信息来源与可信度，倡导健康文明的吃瓜文化，不传谣不信谣。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: 'Web端与移动App无缝衔接，随时随地掌握最新爆料动态。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            本站特色
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            为什么80000+吃瓜群众选择我们
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {features.map((feat) => (
              <div
                key={feat.title}
                className="bg-background-50 rounded-xl p-5 md:p-6 text-center group cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feat.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}